import { object, string, TypeOf } from 'yup'

export const userProfileFormSchema = object({
  aliasId: string()
    .required('ユーザーIDは必須です。')
    .matches(/^[0-9a-zA-Z]+$/, '半角英数字のみ')
    .default(''),
  name: string().required('ユーザーネームは必須です。').default(''),
  icon: string().ensure().default(''),
  coverImage: string().ensure().default(''),
  comment: string().ensure().default(''),
}).defined()

export type UserProfileFormValues = TypeOf<typeof userProfileFormSchema>
